import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 300px 1fr;
  grid-template-rows: calc(100vh - 60px);
`;
